import { render, staticRenderFns } from "./AddonsTariff.vue?vue&type=template&id=492bf8fc"
import script from "./AddonsTariff.vue?vue&type=script&lang=ts"
export * from "./AddonsTariff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports